<!-- src/App.svelte -->
<script>
  import './lib/styles/app.css'
  import Dashboard from '$routes/Dashboard.svelte'
  import Sidebar from '$components/Sidebar.svelte'
  import TopBar from '$components/TopBar.svelte'
  import ChatPanel from '$components/ChatPanel.svelte'
  import { uiStore } from '$lib/stores'

  let currentView = 'chat'

  function handleNav(view) {
    currentView = view
    uiStore.update(s => ({ ...s, activeView: view }))
  }
</script>

<div class="app" data-theme={$uiStore.theme}>
  <div class="ambient-bg"></div>
  <Sidebar on:navigate={e => handleNav(e.detail)} />
  <main class="main-area">
    <TopBar />
    <div class="content">
      {#if currentView === 'dashboard'}
        <Dashboard />
      {:else if currentView === 'chat'}
        <ChatPanel />
      {:else if currentView === 'agents'}
        <Dashboard view="agents" />
      {:else if currentView === 'settings'}
        <Dashboard view="settings" />
      {:else if currentView === 'leads'}
        <Dashboard view="leads" />
      {:else}
        <Dashboard />
      {/if}
    </div>
  </main>
</div>

<style>
  .app {
    display: flex;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: relative;
    background: var(--bg-primary);
    color: var(--text-primary);
    font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }
  .ambient-bg {
    position: fixed;
    inset: 0;
    z-index: 0;
    background: 
      radial-gradient(ellipse at 20% 50%, rgba(120, 80, 255, 0.15) 0%, transparent 50%),
      radial-gradient(ellipse at 80% 20%, rgba(0, 180, 255, 0.1) 0%, transparent 50%),
      radial-gradient(ellipse at 60% 80%, rgba(255, 100, 200, 0.08) 0%, transparent 50%);
    animation: ambientShift 20s ease-in-out infinite;
  }
  @keyframes ambientShift {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.7; transform: scale(1.05); }
  }
  .main-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    z-index: 1;
    overflow: hidden;
  }
  .content {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
  }
</style>